<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">Microchipping your pet</span><br>
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">

      <img src="/assets/images/general/microchipping.png" class="microchip-vs-gps-image" alt="microchipping">

      <h3 class="mb-4"><strong>Everything you need to know about Microchipping</strong></h3>
      <br>

      <p class="mb-4">
        If you’ve recently taken in a new pet, whether you’ve rescued from a shelter
        or purchased through a breeder, the chances are they’ve been microchipped
        already by a local vet – and if they haven’t, you’ll probably need to look
        into sorting this. But whether that’s mandatory or not for your animal to be
        chipped depends entirely on what species they are – but first, let’s cover the basics.
      </p>
      <br>

      <h5 id="microchip" class="mb-2"><strong>What is a Microchip?</strong></h5>

      <p>
        A microchip is a small device which is implanted by a vet in between
        your pet’s shoulders, under the skin, and measures in around 11-13mm
        – that’s roughly the size of a grain of rice.
      </p>

      <p>
        The procedure is so quick and painless that your pet won’t feel a
        thing and is so small that they’ll never know it’s there.
      </p>

      <p>
        A microchip’s purpose is to identify your pet when scanned using
        the link between the implanted chip, and the database your pet’s
        details remain on. Think of it a bit like a barcode or a QR code
        for your pet.
      </p>

      <p>Therefore, this can be a quick and useful way of being reunited if your pet goes missing. How?</p>

      <ul>
        <li>
          When your lost pet is found, it can be taken to any local vet or animal
          charity where it will be scanned with a small device for a microchip
        </li>
        <li>
          If your pet is microchipped, the scanner will find the microchip number and identify your pet
          along with a home address and contact number, providing you’ve kept your details up to date of course.
        </li>
        <li>
          Once the vet identifies your pet, they can then contact you and reunite you with your best friend in no time.
        </li>
      </ul>

      <br>
      <h5 class="mb-2"><strong>My pet’s been Microchipped – what next?</strong></h5>

      <p>
        As soon as your pet has been chipped, you’ll receive their chip number –
        this is a unique 15-digit number aligned with your pet and will identify
        them should they ever wander too far. Once you have the chip number, you
        can register this with your chip’s database – that’s where we come in!
      </p>

      <p>
        With {{ brandName }}, it’s completely free to register your pet and we offer
        three unique pet protection services to choose from to cover your pet
        should they ever be lost, missing or stolen.
      </p>

      <ngb-alert
        *ngIf="alert"
        class="sticky-top my-3"
        (closed)="closeAlert()"
        style="top: 10px;"
        [type]="alert.type" >
        {{ alert.message }}
      </ngb-alert>

      <div class="row mb-3 mt-5">
        <div class="col-12 mt-3">
          <app-fixed-pricing-table
          *ngIf="!isAuthenticated || (isAuthenticated && user)"
          [viewOnly]="true"
          [showShortDescription]="true"
          [buttonLabel]="'Learn more'"
          [pricingPlans]="pricingPlans"
          [hidePrices]="true"
          (onSelect)="unauthorizedSelect($event)"
          [hideIcons]="true"
          [hasBuyNow]="true"
          [appPriceCardFeatureText]="appPriceCardFeatureText"
          [appAlertPriceCardFeatureText]="appAlertPriceCardFeatureText"
          [showPeachBanner]="true"
          [user]="user"
            >
          </app-fixed-pricing-table>
        </div>
      </div>

      <br>
      <h5 class="mb-2"><strong>Is it compulsory to microchip my pet?</strong></h5>

      <p>This entirely depends on the species of your pet, so let’s break it down.</p>

      <br>
      <div><strong>Dogs</strong></div>
      <p>
        In 2016 it became a legal requirement for all dogs and puppies in the UK
        to be microchipped at no later than eight weeks old – and you can be fined
        up to £500 if your dog is found not to be microchipped. You can arrange for
        a vet to administer the chip, or charities such as Dog’s Trust, Blue Cross
        and Battersea will also be able to do this for free.
      </p>

      <br>
      <div><strong>Cats</strong></div>
      <p>
        As of June 2024 it will be compulsory for all cats and kittens over 20 weeks old to be microchipped.
        Failure to microchip your cat could result in a £500 fine. You can arrange for a qualified professional
        such as a vet to implant the chip, or charities such as Blue Cross and Cat’s Protection will be able to do this for free.
      </p>

      <br>
      <div><strong>Horses</strong></div>
      <p>
        In 2020 it became mandatory for all horses, ponies and donkeys in the UK
        to be microchipped – and you can be fined up to £200 if your animal is
        found without one. A vet can administer the chip and this will cost
        between £25 - £30.
      </p>

      <br>
      <div><strong>Small Animals</strong></div>
      <p>
        Rabbits, Pets, Tortoises and other smaller animals can also be microchipped
        and although this isn’t required by law, it’s highly recommended and gives
        you the best possible chance of reuniting should they escape, go missing or
        be stolen.
      </p>

      <br>
      <h5 class="mb-2"><strong>Can I track my pet’s location if they’re microchipped?</strong></h5>

      <div [innerHTML]="microchippingYourPetTrackPetsLocationText"></div>
    </div>
  </div>

  <app-footer-cards>
  </app-footer-cards>

</div>
